module.exports = __webpack_public_path__ + "static/David-4fd0a6adc94482b80743f2e1961f0e97.png";